.month {
  min-height: 259px;
}
